import { LoadState } from "../../constants/enums";

export interface IUtilityState {
  list: IUtilityResponse[];
  totalRecords: number;
  loading: LoadState;
}

export interface IUtilityBranchCode {
  producer_code: string[];
  old_branch_code: string | null;
  new_branch_code: string | null;
  status: string;
}

export interface IUtilityCSRCode {
  producer_code: string[];
  branch_code: string[];
  type_of_policy: string[];
  customer_name: string[];
  customer_code: string[];
  csr_code: string;
  status: string;
}

export interface IUtilityProducerCode {
  producer_code: string[];
  branch_code: string[];
  type_of_policy: string[];
  customer_name: string[];
  customer_code: string[];
  new_producer_code: string;
  status: string;
}
export interface IUtilityTaxPercentage {
  producer_code: string[];
  branch_code: string[];
  type_of_policy: string[];
  customer_name: string[];
  customer_code: string[];
  agency_or_direct_bill: string | null;
  default_tax_region: string | null;
  new_tax_percentage: string | null;
  transaction_start_date: string | null;
  transaction_end_date: string | null;
  status: string;
}
export interface IUtilityCommissionPercentage {
  producer_code: string[];
  branch_code: string[];
  type_of_policy: string[];
  customer_name: string[];
  customer_code: string[];
  new_commission_percentage: string | null;
  transaction_start_date: string | null;
  transaction_end_date: string | null;
  status: string;
}
export interface IUtilityProducerPercentage {
  producer_code: string[];
  branch_code: string[];
  type_of_policy: string[];
  customer_name: string[];
  customer_code: string[];
  house_percentage: number | null;
  producer_one_percentage: number | null;
  producer_two_percentage: number | null;
  producer_three_percentage: number | null;
  branch_percentage: number | null;
  transaction_start_date: string | null;
  transaction_end_date: string | null;
  status: string;
}
export interface IUtilityMarkCommissionPaid {
  branch_code: string[];
  producer_code: string[];
  insurer_code: string[];
  producer_paid: string | null;
  producer_paid_date: string | null;
  company_paid: string | null;
  company_paid_date: string | null;
  payment_paid: string | null;
  payment_paid_date: string | null;
  transaction_start_date: string | null;
  transaction_end_date: string | null;
  status: string;
}

export interface IUtilityCustomerCode {
  old_customer_id: string | null;
  new_customer_id: string | null;
}

export interface IUtilityLineOfBusinessPolicyMerge {
  old_customer_policy_id: string | null;
  new_customer_policy_id: string | null;
}

export interface IUtilityResponse {
  utility_log_code: string | null;
  utility_type: string | null;
  incoming_payload: {
    [key: string]: number;
  };
  table_name: string | null;
  status: string;
}

export interface IUtilityResponseHistory {
  utility_log_code: string | null;
  utility_type: string | null;
  incoming_payload: {
    [key: string]: string;
  };
  table_name: string | null;
  customer_policy_id: string | null;
  type_of_policy: string | null;
  producer_code: string | null;
  branch_code: string | null;
  customer_name: string | null;
  customer_code: string | null;
  csr_code: string | null;
  new_producer_code: string | null;
  previous_id: string | null;
  current_id: string | null;
  query: string | null;
  process_status: string | null;
  status: string;
  created_by_id: string | null;
  modified_by_id: string | null;
  create_ts: string | null;
  insert_ts: string | null;
}
export interface IUtilityAssignPolicy {
  customer_policy_id: number | null;
  customer_id: number | null;
}

export const initialUtilityState: IUtilityState = {
  list: [],
  loading: LoadState.NotLoaded,
  totalRecords: 0,
};

export const initialUtilityBranchCode: IUtilityBranchCode = {
  new_branch_code: "",
  old_branch_code: "",
  producer_code: [],
  status: "ACTIVE",
};

export const initialUtilityCSRCode: IUtilityCSRCode = {
  producer_code: [],
  branch_code: [],
  type_of_policy: [],
  customer_name: [],
  customer_code: [],
  csr_code: "",
  status: "ACTIVE",
};

export const initialUtilityProducerCode: IUtilityProducerCode = {
  producer_code: [],
  branch_code: [],
  type_of_policy: [],
  customer_name: [],
  customer_code: [],
  new_producer_code: "",
  status: "ACTIVE",
};

export const initialUtilityTaxPercentage: IUtilityTaxPercentage = {
  producer_code: ["All-Producer"],
  branch_code: ["All-Branch"],
  type_of_policy: ["All-Policy"],
  customer_name: [],
  customer_code: [],
  agency_or_direct_bill: "A",
  default_tax_region: null,
  new_tax_percentage: null,
  transaction_start_date: null,
  transaction_end_date: null,
  status: "ACTIVE",
};

export const initialUtilityCommissionPercentage: IUtilityCommissionPercentage =
  {
    producer_code: ["All-Producer"],
    branch_code: ["All-Branch"],
    type_of_policy: ["All-Policy"],
    customer_name: [],
    customer_code: [],
    new_commission_percentage: null,
    transaction_start_date: null,
    transaction_end_date: null,
    status: "ACTIVE",
  };
export const initialUtilityProducerPercentage: IUtilityProducerPercentage = {
  producer_code: ["All-Producer"],
  branch_code: ["All-Branch"],
  type_of_policy: ["All-Policy"],
  customer_name: [],
  customer_code: [],
  house_percentage: null,
  producer_one_percentage: null,
  producer_two_percentage: null,
  producer_three_percentage: null,
  branch_percentage: null,
  transaction_start_date: null,
  transaction_end_date: null,
  status: "ACTIVE",
};
export const initialUtilityMarkCommissionPaid: IUtilityMarkCommissionPaid = {
  branch_code: ["All-Branch"],
  producer_code: ["All-Producer"],
  insurer_code: [],
  payment_paid: null,
  payment_paid_date: null,
  producer_paid: null,
  producer_paid_date: null,
  company_paid: null,
  company_paid_date: null,
  transaction_start_date: null,
  transaction_end_date: null,
  status: "ACTIVE"
};

export const initialUtilityCustomerCode: IUtilityCustomerCode = {
  old_customer_id: null,
  new_customer_id: null,
};

export const initialUtilityAssign: IUtilityAssignPolicy = {
  customer_policy_id: null,
  customer_id: null,
};

export const initialUtilityLineOfBusinessPolicyMerge: IUtilityLineOfBusinessPolicyMerge =
  {
    old_customer_policy_id: null,
    new_customer_policy_id: null,
  };
